module.exports = function getResource(label) {
    let resources = {
        onlyAFewLeft: 'plus que quelques articles en stock'
    };
    return resources[label];
};
